// extracted by mini-css-extract-plugin
export default {"reasonLabel":"AuditStatusTableRow_reasonLabel__7AWpr","imageLink":"AuditStatusTableRow_imageLink__ObAOt"};